import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { faBootstrap, faGithub, faJs, faPython, faReact } from "@fortawesome/free-brands-svg-icons";
import SQLAlchemyIcon from "../img/icons/sqlalchemyicon.png";
import { ArrowIcon } from "./ArrowIcon";
import Conmo from "../img/MiConmo.png";
import ConmoPresentation from "../img/ConmoPresentationorigi.gif";
import NotesPresentation from "../img/React-Notes-Presentation.gif";
import Notes from "../img/react-notes.png";
import i18next from 'i18next';

export const Projects = () => {
    const [selectedProject, setSelectedProject] = useState(ConmoPersonalFinances);
    
    return (
        <>
            <div className="d-flex align-items-center justify-content-center flex-column text-center text-white">
                <h1 className="section-title">{i18next.t('projects')}</h1>
                <div className="section-content d-flex justify-content-between py-2" id="projectsContent">
                    <div className="projects-menu">
                        <div className="project-wrapper">
                            <Project 
                                miniature={ConmoPersonalFinances.miniatureImage}
                                imageDescription={ConmoPersonalFinances.imageDescription}
                                setProject={ConmoPersonalFinances}
                                setSelectedProject={setSelectedProject}
                                miniatureTitle={'Conmo'}
                            />
                        </div>
                        <div className="project-wrapper">
                            <Project 
                                miniature={ReactNotes.miniatureImage}
                                imageDescription={ReactNotes.imageDescription}
                                setProject={ReactNotes}
                                setSelectedProject={setSelectedProject}
                                miniatureTitle={'React notes'}
                            />
                        </div>
                    </div>
                    <ProjectDetails 
                        selectedProject={selectedProject}
                        videoPresentation={(selectedProject).presentation}
                        description={(selectedProject).description}
                        links={(selectedProject).links}
                    />
                </div>
            </div>
        </>
    );
};

const Project = ({ miniature, imageDescription, setProject, setSelectedProject, miniatureTitle }) => {
    
    const selectProject = () => {
        setSelectedProject(setProject);
    };

    return (
        <>
            <div className="project-container">
                <p className="miniature-title">{miniatureTitle}</p>
                <img src={miniature} className="custom-img rounded-bottom pointer" alt={imageDescription} onClick={selectProject}/>
            </div>
        </>
    );
};


const ConmoPersonalFinances = {
    miniatureImage: Conmo,
    imageDescription: 'Conmo', 
    presentation: ConmoPresentation,
    title: 'conmoPersonalFinances.title',
    description1: 'conmoPersonalFinances.description1',
    description2: 'conmoPersonalFinances.description2',
    description:
        <>
            <p className="d-flex justify-content-between align-items-center gap-2">
                Backend:
                <FontAwesomeIcon icon={faPython} size="2x" />
                <img type="button" style={{ maxWidth: "50px", width: "70%", height: "25px"}} src="https://jwt.io/img/logo.svg" alt="jwt logo"></img>
                <img type="button" style={{ width: "45px", height: "40px"}} src={SQLAlchemyIcon} alt="SQLAlchemy logo"></img>
            </p>
            <p className="d-flex justify-content-between align-items-center gap-2">
                Frontend:
                <FontAwesomeIcon icon={faJs} size="2x" />
                <FontAwesomeIcon icon={faReact} size="2x" />
                <FontAwesomeIcon icon={faBootstrap} size="2x" />
            </p>    
        </> , 
    links: 
        <>
            <div className="d-flex justify-content-between align-items-center"> 
                Render
                <div className="ps-3">
                    <ArrowIcon />
                </div>
                <a href="https://sample-service-name-ivq4.onrender.com/" alt="Conmo" className="btn text-white menu-tooltip ms-0 ps-0" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faCoins} size="2x" />
                </a>
            </div>
            <div className="d-flex justify-content-between align-items-center">
                Github
                <div className="ps-3">
                    <ArrowIcon />
                </div>
                <a href="https://github.com/begonufer/Conmo-Personal-Finances" alt="Conmo" className="btn text-white menu-tooltip ms-0 ps-0" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faGithub} size="2x" />
                </a>
            </div>
        </>,
}

const ReactNotes = {
    miniatureImage: Notes,
    imageDescription:"Notes",
    presentation: NotesPresentation,
    title: 'reactNotes.title',
    description1: 'reactNotes.description1',
    description2: 'reactNotes.description2',
    description:
        <>
            <p className="d-flex justify-content-between align-items-center w-100 px-5">
                Frontend:
                <FontAwesomeIcon icon={faJs} size="2x" />
                <FontAwesomeIcon icon={faReact} size="2x" />
                <FontAwesomeIcon icon={faBootstrap} size="2x" />
            </p>    
        </> , 
    links: 
        <>
            <p className="d-flex justify-content-between align-items-center ms-2">
                Github
                <div className="ps-3">
                    <ArrowIcon />
                </div>
                <a href="https://github.com/begonufer/Notes-with-React-and-Fetch" alt="ReactNotes" className="btn text-white menu-tooltip ms-0 ps-0" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faGithub} size="2x" />
                </a>
            </p>
        </>,
}



const ProjectDetails = ({ selectedProject, videoPresentation, description, links }) => {
    return (
        <>
            <div className="project-complete rounded justify-content-between align-items-center">
                <div className="image-container">
                    <img src={videoPresentation} alt="ConmoPresentation" className="proyect-img rounded"/>
                </div>
                <div className="d-flex align-items-center justify-content-center flex-column p-2">
                    <h3 className="fw-bold">{i18next.t(selectedProject.title)}</h3>
                    <p>{i18next.t(selectedProject.description1)}</p>
                    <p>{i18next.t(selectedProject.description2)}</p>
                    {description}
                    <div className="justify-content-between mt-2 gap-4">
                        {links}
                    </div>
                </div>
            </div>
        </>
    );
};

